var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.734863C19.1045 0.734863 20 1.67838 20 2.84229V19.7026C19.9999 20.8665 19.1045 21.8101 18 21.8101H13V13.8755H15.5625L15.9736 10.9009H13V9.62939C13 8.48891 13.3053 7.92534 14.3389 7.92529H16V5.07959C15.7079 5.03893 15.091 4.94971 13.9248 4.94971C11.4896 4.94976 10 6.27838 10 9.30322V10.9009H7V13.8755H10V21.8101H2C0.895477 21.8101 7.49527e-05 20.8665 0 19.7026V2.84229C4.732e-05 1.67838 0.89546 0.734863 2 0.734863H18Z",
    fill: "#28527A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8d55265feab2c598ad94713610bcd0ae.svg";
export { ForwardRef as ReactComponent };